// extracted by mini-css-extract-plugin
module.exports = {"editorWrapper":"styles__editorWrapper___3Gmo1","changeWrapper":"styles__changeWrapper___1uNq3"};